<script>
import Layout from '@layouts/main'
import { hmdaMethods } from '@state/helpers'
import { hmdaACL } from '@/src/utils/accesslevels'
import common from '@/src/state/modules/common'
import HmdaHeader from '@/src/components/HMDA/HmdaHeader.vue'
import format from 'date-fns/format'

export default {
  components: { Layout, HmdaHeader },
  data() {
    return {
      myUsername: '',
      showSpinner: false,
      headerTitle: 'Management & Operation',
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'HMDA',
          to: { path: '/hmda' },
        },
        { text: 'ManagementAndOperation', active: true },
      ],
      customer: null,
      dateFrom: '',
      dateTo: '',
    }
  },
  computed: {},
  async mounted() {
    hmdaACL.initializeAccessControls()
    await this.getSelectedCustomer().then((res) => {
      this.customer = res
    })
  },
  methods: {
    ...hmdaMethods,
    async onClickManagementAndOperationDownload() {
      if (!this.dateFrom || !this.dateTo) {
        this.$refs.msg.showError('Please select both start and end dates.')
        return
      }

      this.showSpinner = true
      this.downloadManagementAndOperationReport({
        dateFrom: format(this.dateFrom,'YYYY-MM-DD'),
        dateTo: format(this.dateTo,'YYYY-MM-DD'),
      })
        .then((response) => {
          if (response.data) {
            const url = window.URL.createObjectURL(
              new Blob([common.fixUnicodeCharsCsv(response.data)])
            )
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'ManagementAndOperationReport.csv')
            document.body.appendChild(link)
            link.click()

          }
          else {
            this.$refs.msg.showError('Failed to generate the Management and Operation report. Please try again later.');
          }
        })
        .finally(() => {
          this.showSpinner = false
        })
    }
  },
}
</script>

<template>
  <Layout>
    <BaseSpinner v-if="showSpinner" />
    <BaseModalLayout ref="msg" modal-size="md" />
    <BaseModalLayout ref="errorView" hide-cancel modal-size="md" />
    <HmdaHeader :crumbs="breadcrumbs" />
    <div class="body--wrapper mt-1 bg-white container">
      <BaseTitleMenu
        :heade-title="headerTitle"
        class="text-capitalize border-bottom pb-3"
      />
      <p>Management And Operation Report</p>

      <b-row class="align-items-end mt-5">
        <!-- Start Date Input -->
        <b-col md="4">
          <label for="dateFrom">Start Date</label>
          <BaseDate
            id="dateFrom"
            v-model="dateFrom"
            type="date"
          />
        </b-col>

        <!-- End Date Input -->
        <b-col md="4">
          <label for="dateTo">End Date</label>
          <BaseDate
            id="dateTo"
            v-model="dateTo"
            type="date"
          />
        </b-col>

        <!-- Download Button -->
        <b-col md="4">
          <template>
            <BaseEButton
              class="mt-md-0 mt-2"
              @click="onClickManagementAndOperationDownload"
            >
              Download Report
            </BaseEButton>
          </template>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
